
document.addEventListener('DOMContentLoaded', () => {
  const easingOutQuint = (x, t, b, c, d) => c * ((t = t / d - 1) * t * t * t * t + 1) + b;

  function smoothScrollPolyfill(node, key, target) {
    const startTime = Date.now();
    const offset = node[key];
    const gap = target - offset;
    const duration = 1000;
    let interrupt = false;

    const step = () => {
      const elapsed = Date.now() - startTime;
      const percentage = elapsed / duration;

      if (interrupt) {
        return;
      }

      if (percentage > 1) {
        cleanup();
        return;
      }

      node[key] = easingOutQuint(0, elapsed, offset, gap, duration);
      requestAnimationFrame(step);
    };

    const cancel = () => {
      interrupt = true;
      cleanup();
    };

    const cleanup = () => {
      node.removeEventListener('wheel', cancel);
      node.removeEventListener('touchstart', cancel);
    };

    node.addEventListener('wheel', cancel, { passive: true });
    node.addEventListener('touchstart', cancel, { passive: true });

    step();

    return cancel;
  }

  function testSupportsSmoothScroll() {
    let supports = false;
    try {
      let div = document.createElement('div');
      div.scrollTo({
        get behavior() {
          supports = true;
          return 'smooth';
        },
        top: 0,
      });
    } catch (err) {
      console.warn(err);
    }
    return supports;
  }

  const hasNativeSmoothScroll = testSupportsSmoothScroll();

  function smoothScroll(node, topOrLeft, horizontal) {
    if (hasNativeSmoothScroll) {
      return node.scrollTo({
        [horizontal ? 'left' : 'top']: topOrLeft,
        behavior: 'smooth',
      });
    } else {
      return smoothScrollPolyfill(node, horizontal ? 'scrollLeft' : 'scrollTop', topOrLeft);
    }
  }

  function debounce(func, ms) {
    let timeout;
    return () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        func();
      }, ms);
    };
  }

  const indicators = document.querySelectorAll('.indicator-button');
  const indicatorsLength = indicators.length;
  const scroller = document.querySelector('slider-component ul.product__media-list.slider') || document.querySelector('slideshow-component-infinite ul.product__media-list.slider');
  if (indicators.length <= 1) {
    indicators[0].closest('.indicators').style.display = 'none';
  }

  function setDataPressed(index) {
    indicators.forEach((indicator, i) => {
      indicator.setAttribute('data-pressed', !!(i === index));
    });
  }

  indicators.forEach((indicator, i) => {
    indicator.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDataPressed(i);
      const scrollLeft = Math.floor(scroller.scrollWidth * (i / indicators.length));
      smoothScroll(scroller, scrollLeft, true);
    });
  });

  scroller.addEventListener('scroll', () => {
    let index = Math.round((scroller.scrollLeft / scroller.scrollWidth) * (indicators.length + 2));
    if (index === 0) {
      setDataPressed(indicatorsLength - 1);
    } else if (index === (indicatorsLength + 1)) {
      setDataPressed(0);
    } else {
      setDataPressed(index - 1);
    }
  });

  scroller.dispatchEvent(new Event('scroll'));
});
